import { useEffect } from 'react';

type VersionResponse = {
    version: string;
};

export function useAppVersionCheck(interval: number = 60000): void {
    useEffect(() => {
        let isMounted = true;

        const checkVersion = async (): Promise<void> => {
            try {
                const res = await fetch('/api/version?v=' + Date.now(), {
                    cache: 'no-store',
                });

                if (!res.ok) {
                    throw new Error(`HTTP error: ${res.status}`);
                }

                const data: VersionResponse = await res.json();

                const currentVersion = process.env.REACT_APP_VERSION;

                if (!currentVersion) {
                    console.warn('REACT_APP_VERSION is not defined');
                    return;
                }
                console.log("currentVersion : " + currentVersion)
                if (isMounted && data.version !== currentVersion) {
                    console.log('🔄 New version detected:', data.version);

                    //const shouldReload = window.confirm('New version available. Reload?');
                    //if (shouldReload) {

                    // 🔥 Очистка Cache Storage (если используется)
                    if ('caches' in window) {
                        const cacheNames = await caches.keys();
                        await Promise.all(cacheNames.map(name => caches.delete(name)));
                    }

                    window.location.reload();
                    //}
                }
            } catch (error) {
                console.error('Version check failed:', error);
            }
        };

        // первый запуск сразу
        checkVersion();

        const intervalId = setInterval(checkVersion, interval);

        return () => {
            isMounted = false;
            clearInterval(intervalId);
        };
    }, [interval]);
}
